import { Link, useLocation } from 'react-router-dom';
import './PageWrapperSidebarItem.css';

export interface PropsIcon {
  className?: string;
  width?: number;
  height?: number;
  color?: string;
}

interface Props {
  title: string;
  href: string;
  isShortSideBar: boolean;
  Icon: React.FC<PropsIcon>;
  onHide?: () => void;
}

export const PageWrapperSidebarItemLink: React.FC<Props> = ({
  title,
  href,
  isShortSideBar,
  Icon,
  onHide
}) => {
  const location = useLocation();
  const className = location.pathname === href ? 'nav-item active' : 'nav-item';
  const classNameIcon =
    location.pathname === href ? 'icon icon--active' : 'icon';

  return (
    <ul className="nav flex-column">
      <li className={className}>
        <Link
          className="nav-link d-flex align-items-center gap-2"
          to={href}
          onClick={onHide}
        >
          <Icon className={classNameIcon} />
          {!isShortSideBar && title}
        </Link>
      </li>
    </ul>
  );
};
